import { createClient } from '@supabase/supabase-js';
import { readBrowserEnvironment } from './env';

export const browserEnvironment = readBrowserEnvironment(import.meta.env);

export const supabase = createClient(
  browserEnvironment.VITE_SUPABASE_URL,
  browserEnvironment.VITE_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  }
);
